import SalesGoalsMassiveUpload from './containers/SalesGoalsMassiveUpload';

export default SalesGoalsMassiveUpload;
